module.exports = __webpack_public_path__ + "static/media/STPProjectPreview2w1100@1x.42143ddd.webp";